import React from 'react'
import styled, { css } from 'styled-components'

import i18n from 'live/services/i18n'

import { options } from '../../utils'
import ListDetails from '../ListDetails'

const normalizeString = (str: string): string =>
    str
        ?.toLowerCase()
        ?.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

const BowtieDetails = ({ data, goBack, toInfo, handlerClick }) => {
    const status = normalizeString(data?.json?.status)
    const key = data?.json?.key?.replace(/\s+/g, '')
    const title = data?.json?.title?.replace(data?.json?.key, '')
    const mitigations = ['threats', 'consequences']

    return (
        <BowtieDetailsContainer applyOverflow={!!(data?.json?.consequences_count + data?.json?.threats_count > 8)}>
            <header className="DetailsContainer_header">
                <button onClick={goBack}>
                    <i className="far fa-chevron-left"></i>
                    {key}
                </button>
                <h4 className="DetailsContainer_header-title">{title}</h4>
                <div className="DetailsContainer_header-subtitle">
                    <small>
                        {i18n('Frequency')}{' '}
                        <span className="Bowtie_value_bold">
                            {data?.event?.bowtieFrequency?.toExponential(2)} {/* 10<sup>-1</sup> */}
                        </span>
                    </small>
                    <span className="Bowtie_pipe">|</span>
                    {status && (
                        <small style={{ color: options[status].color }}>
                            <i className={`far fa-${options[status].icon}`}></i>
                            {i18n(options[status]?.label)}
                        </small>
                    )}
                </div>
            </header>
            {mitigations?.map((e, i) => {
                return (
                    <ListDetails
                        name={key}
                        data={{ a: data?.json?.hazard && data?.json?.hazard[e], b: data?.event && data?.event[e] }}
                        toInfo={toInfo}
                        type={e}
                        handlerClick={handlerClick}
                    />
                )
            })}
        </BowtieDetailsContainer>
    )
}
export default BowtieDetails

const BowtieDetailsContainer = styled.section<{ applyOverflow: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
    height: 100%;

    background: #fff;

    ${({ applyOverflow }) =>
        applyOverflow
            ? css`
                  overflow-y: auto;
              `
            : ''}

    .DetailsContainer_header {
        padding: 16px;
        h4 {
            margin-bottom: 4px;
        }
        button {
            cursor: pointer;
            margin: 0;
            padding: 0;
            appearance: none;
            border: none;
            outline: none;
            background: none;
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 16px;
            color: #37a3ef;
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            i {
                margin-right: 6px;
            }
        }
        i.far,
        i.fas {
            margin-right: 6px;
        }
        .DetailsContainer_header-title {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            color: #364159;
            margin: 0;
        }

        .DetailsContainer_header-subtitle {
            display: flex;
        }

        .DetailsContainer_header-subtitle small {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            display: flex;
            align-items: center;
            color: #364159;
        }
    }

    .ListDetails {
    }

    .Bowtie_value_bold {
        font-weight: 600;
        color: #364159;
        margin-left: 4px;
    }
    .Bowtie_pipe {
        margin: 0 8px;
    }
`
